;
export default {
    // 用户角色同步接口
    syncUserAndRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/syncUserAndRoleInfo', params, response);
    },
    // 用户查询接口
    listUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/queryUserInfoList', params, response);
    },
    // 消息添加接口
    editUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/editUserInfo', params, response);
    },
    // 查询用户树形
    findUserTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/queryUserOrgTree', params, response);
    }
};
